import styled from 'styled-components';

const BigCard = styled.div`
  background-color: ${({theme})=> theme.colors.backgroundLight};
  border-radius: ${({theme}) => theme.universalBorderRadius};
  padding: 1em;
`;

export default BigCard;